import { AlignLeft, ChevronDown } from "lucide-react";

import { MediaUnavailable } from "@/components/ui/media-unavailable";

import { MessageAudioPlayer } from "./message-audio-player";

export function MessageAudio({
	src,
	transcription,
}: {
	src: string | null;
	transcription: string | null;
}) {
	return (
		<div className="flex w-72 max-w-full flex-col">
			{src && <MessageAudioPlayer key={src} src={src} />}
			{!src && <MediaUnavailable kind="audio" />}
			{transcription && (
				<details className="group mt-2 border-t border-primary/10 pt-2">
					<summary className="flex cursor-pointer list-none items-center gap-2 rounded-md py-1 text-xs font-medium text-primary focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring [&::-webkit-details-marker]:hidden">
						<AlignLeft className="size-3.5" aria-hidden="true" />
						Transcrição
						<ChevronDown
							className="ml-auto size-3.5 transition-transform group-open:rotate-180"
							aria-hidden="true"
						/>
					</summary>
					<p className="pb-1 pt-2 whitespace-pre-wrap break-words text-sm leading-relaxed text-foreground">
						{transcription}
					</p>
				</details>
			)}
		</div>
	);
}
